export {modalOptions, PeopleSelectorModalComponent as PeopleSelectorModal} from './PeopleSelectorModalComponent';



// WEBPACK FOOTER //
// ./src/js/personnel/components/PeopleSelectorModal/index.js